<template>
<v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1200px">

      <v-card class="elevation-0">

        <v-toolbar dark color="primary" dense>
          <v-toolbar-title>Booking detail</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container>

            <v-row>
              <v-col cols="12">
                <m-booking-detail v-if="booking && booking.type" :booking="booking" :type="booking.type"></m-booking-detail>
              </v-col>
            </v-row>


            <v-row >
              <v-col cols="6">
                <m-client-detail v-if="booking.clientId" :id="booking.clientId" :address="booking.pick_address"></m-client-detail>
              </v-col>
              <v-col cols="6">
                <m-driver-detail v-if="booking.driverId" :id="booking.driverId"></m-driver-detail>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <m-destination-detail v-if="booking.destinationId" :id="booking.destinationId"></m-destination-detail>
              </v-col>
            </v-row>
          </v-container>

      </v-card>
    </v-dialog>
    </v-row>
</template>
<script>
  import MBookingDetail from '@/components/booking/detail';
  import MClientDetails from '@/components/client/details';
  import MDriverDetails from '@/components/driver/details';
  import MDestinationDetails from '@/components/destination/details';
  export default {
    props: ['dialog', 'booking'],
    components: {
      'm-booking-detail': MBookingDetail,
      'm-client-detail': MClientDetails,
      'm-driver-detail': MDriverDetails,
      'm-destination-detail': MDestinationDetails
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$emit('close');
      },
      getData () {

      }
    },
    created () {
      this.getData()
    },
    watch: {
      booking () {
        console.log('updated detail:', this.booking)
      }
    }
  }
</script>
